"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
  var moduleName = "depa.choiceSlot";
  var componentName = "choiceSlot";

  var bindings = {
    resolve: "<?",
    depaId: "=?"
  };

  var templateUrl = "app/pages/depas/choiceSlot/choiceSlot.html";

  var Controller = function () {
    /** @ngInject */
    function Controller($rootScope, $scope, $element, $timeout, moment, DepasService) {
      _classCallCheck(this, Controller);

      this.$rootScope = $rootScope;
      this.$element = $element;
      this.$timeout = $timeout;
      this.$scope = $scope;

      this.moment = moment;

      this.oneAtATime = true;

      this.DepasService = DepasService;
    }

    _createClass(Controller, [{
      key: "resetTimeout",
      value: function resetTimeout() {
        var _this = this;

        console.log("resetTimeout");

        if (this.timer) {
          clearTimeout(this.timer);
        }

        this.timer = setTimeout(function () {
          _this.close();
        }, 60000);
      }
    }, {
      key: "done",
      value: function done(slot) {
        var _this2 = this;

        if (this.timer) {
          clearTimeout(this.timer);
        }

        console.log("done", slot);

        this.$timeout(function () {
          if (_this2.$scope.$parent) {
            _this2.$scope.$parent.$close(slot);
          }
        }, 0);
      }
    }, {
      key: "refresh",
      value: function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var timezone, json, slotsInDb, slots, slot;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.depaId = this.resolve.params.depaId;

                  Notiflix.Loading.standard("Cliquez pour interrompre le chargement...");
                  timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.replace("/", "-");
                  json = void 0;
                  _context.prev = 4;
                  _context.next = 7;
                  return this.DepasService.get("mobile/freeSlots/" + this.depaId.replace("$", "") + "/" + timezone);

                case 7:
                  json = _context.sent;
                  _context.next = 15;
                  break;

                case 10:
                  _context.prev = 10;
                  _context.t0 = _context["catch"](4);

                  Notiflix.Loading.remove();
                  Notiflix.Report.failure("Erreur", "Impossible de récupérer les créneaux disponibles", "OK");
                  return _context.abrupt("return");

                case 15:
                  slotsInDb = json.data;
                  slots = [];

                  for (slot in slotsInDb) {
                    if (slotsInDb[slot].length) {
                      slots.push(slotsInDb[slot]);
                    }
                  }

                  slots = slots.sort(function (a, b) {
                    return new Date(a[0].start).getTime() - new Date(b[0].start).getTime();
                  });
                  this.slots = slots;

                  this.$timeout(function () {}, 0);
                  Notiflix.Loading.remove();

                case 22:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[4, 10]]);
        }));

        function refresh() {
          return _ref.apply(this, arguments);
        }

        return refresh;
      }()
    }, {
      key: "$onInit",
      value: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var _this3 = this;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  document.addEventListener("keydown", function (e) {
                    if (e.keyCode == 27 && _this3.timer) {
                      clearTimeout(_this3.timer);
                    }
                  });

                  this.resetTimeout();

                  _context2.next = 4;
                  return this.refresh();

                case 4:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function $onInit() {
          return _ref2.apply(this, arguments);
        }

        return $onInit;
      }()
    }, {
      key: "$onDetroy",
      value: function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  console.log("close modal choiceSlot");
                  Notiflix.Loading.remove();

                  if (this.timer) {
                    clearTimeout(this.timer);
                  }

                case 3:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this);
        }));

        function $onDetroy() {
          return _ref3.apply(this, arguments);
        }

        return $onDetroy;
      }()
    }, {
      key: "close",
      value: function close() {
        if (this.$scope.$parent) {
          this.$scope.$parent.$close(null);
        }
      }
    }]);

    return Controller;
  }();

  angular.module(moduleName).component(componentName, {
    templateUrl: templateUrl,
    bindings: bindings,
    transclude: true,
    controller: Controller
  });
})();